module.exports = __webpack_public_path__ + "static/media/logo.b5643af3.svg";